import './SlideDrawer.scss';
import {useTranslation} from "react-i18next";
import SideFilterDrawerContainer from "../../pages/SideFilterDrawer/SideFilterDrawerContainer";
import Close from '@mui/icons-material/Close';
import { Modal, Slide } from '@mui/material';

interface Props {
    changedFilters: any
    selectedDate?: string
    selectedFilters: any
    show: boolean
    setChangedFilters: Function
    // setFilterData: Function
    setPairingList?: Function
    setSaveFilters: Function
    setSelectedFilters: Function
    setToggle: Function
}

const SliderDrawer = ({   
    changedFilters,  
    selectedDate, 
    selectedFilters,
    show, 
    setChangedFilters,
    // setFilterData, 
    setPairingList, 
    setSaveFilters,
    setSelectedFilters,  
    setToggle
}: Props) => {

    const { t } = useTranslation();
    return (
        <Modal open={show} onClose={(_) => setToggle(false)} closeAfterTransition={true} >
            <Slide direction="left" in={show} mountOnEnter unmountOnExit timeout={{enter:350, exit: 250}}>
                <div className="side-drawer">
                    <div className="filter-title">
                        <div>
                            <i className='icon-filter'/> {t('Filter.title')}
                        </div>
                        <Close className='icon-close-modal' onClick={() => setToggle(false)} />
                    </div>
                    <SideFilterDrawerContainer 
                        changedFilters={changedFilters}
                        selectedDate={selectedDate} 
                        selectedFilters={selectedFilters} 
                        show={show} setToggle={setToggle} 
                        setChangedFilters={setChangedFilters}
                        // setFilterData={setFilterData} 
                        setPairingList={setPairingList} 
                        setSaveFilters={setSaveFilters}
                        setSelectedFilters={setSelectedFilters}  
                    />
                </div>
            </Slide>
        </Modal> 
    );
};

export default SliderDrawer;
